import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../common/DeleteModal";
import { Dropdown } from "react-bootstrap";
import { Translate } from "../../../Enums/Tranlate";
import RoleService from "../../../../services/RoleService";

const CardItem = ({ item, index, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const roleService = new RoleService();
	const navigate = useNavigate();

	return (
		<tr key={index} className="text-center">
			<td>{item?.name}</td>
			<td>
				<Dropdown>
					<Dropdown.Toggle className="light sharp i-false">
						<i className="la la-ellipsis-v" style={{ fontSize: "27px" }}></i>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						<Dropdown.Item
							onClick={() => {
								navigate(`/roles/${item.id}`, { state: item });
							}}>
							{Translate[lang].edit}
						</Dropdown.Item>
						<Dropdown.Item onClick={() => setDeleteModal(true)}>
							{Translate[lang].delete}
						</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.name}
					deletedItem={item}
					modelService={roleService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
